import { apiDataChangeRequestUserService } from '@api/services/dataChangeRequestUser.apiService';
import { makeAutoObservable } from 'mobx';
import { MobxRootStore } from './mobx.store';

export class PopupModalStore {
  mobxStore: MobxRootStore;

  private _isBankCardUpdateRequired = false;
  private _isUpdateBankCardModalShown = false;

  constructor(mobxStore: MobxRootStore) {
    this.mobxStore = mobxStore;
    makeAutoObservable(this);
  }

  fetchUserBankCardRequiresUpdatesAndShowModal = async () => {
    if (this._isBankCardUpdateRequired) {
      this.openCloseUpdateBankCardModal(true);
    }

    try {
      const { data: isShowModal } = await apiDataChangeRequestUserService.showDataChangeRequestPopup();

      this._isBankCardUpdateRequired = isShowModal;
      this.openCloseUpdateBankCardModal(isShowModal);
    } catch (error) {
      console.error(error);
    }
  };

  openCloseUpdateBankCardModal = (value: boolean) => {
    this._isUpdateBankCardModalShown = value;
  };

  get isUpdateBankCardModalShown() {
    return this._isUpdateBankCardModalShown;
  }
}
